import service from './service'
import { CONTENT_TYPE } from '@/constants'
import { useUserStoreWithOut } from '@/store/modules/user'
import { md5 } from 'js-md5'

const request = (option: AxiosConfig) => {
  const { url, method, params, data, headers, responseType } = option

  const appId = '10010'
  const secret = '1748997e97beac84c197c4d21e84a911'

  const timestamp = new Date().getTime()
  const nonce = md5(Math.random().toString(36))

  const signStr = `app_id=${appId}&nonce=${nonce}&timestamp=${timestamp}&secret=${secret}`
  const sign = md5(signStr)

  const userStore = useUserStoreWithOut()
  return service
    .request({
      url: url,
      method,
      params,
      data: data,
      responseType: responseType,
      headers: {
        'Content-Type': CONTENT_TYPE,
        ['Authorization']: userStore.getToken ? `Bearer ${userStore.getToken}` : '',
        'X-Erp-Sign': sign,
        'X-Erp-Timestamp': timestamp,
        'X-Erp-Nonce': nonce,
        'X-Erp-AppId': appId,
        'X-Erp-Auth': userStore.getDataAuth,
        'X-Erp-Store': userStore.getCurrentStore,
        ...(localStorage.getItem('preview_tenant_admin_id')
          ? { 'X-Erp-View-As': localStorage.getItem('preview_tenant_admin_id')! }
          : {}),
        ...headers
      }
    })
    .then((res) => {
      return res
    })
    .catch((error: any) => {
      if (error.response?.status === 401) {
        userStore.reset()
      }
      return Promise.reject(error)
    })
}

export default {
  get: <T = any>(option: AxiosConfig) => {
    return request({ method: 'get', ...option }) as Promise<IResponse<T>>
  },
  post: <T = any>(option: AxiosConfig) => {
    return request({ method: 'post', ...option }) as Promise<IResponse<T>>
  },
  delete: <T = any>(option: AxiosConfig) => {
    return request({ method: 'delete', ...option }) as Promise<IResponse<T>>
  },
  put: <T = any>(option: AxiosConfig) => {
    return request({ method: 'put', ...option }) as Promise<IResponse<T>>
  },
  cancelRequest: (url: string | string[]) => {
    return service.cancelRequest(url)
  },
  cancelAllRequest: () => {
    return service.cancelAllRequest()
  }
}
